import httpClient from "@plugins/http";
import { PaginatedResultModel } from "@plugins/common/types.ts";
import {
  ForumTopicModel,
  ForumTopicResourceModel,
} from "@modules/lesson-review/lesson-review-types.ts";
import { ApiResponse } from "@apis/api.ts";

const fetchLessonTeacherReviewTopic = (uuid): Promise<ApiResponse<ForumTopicModel>> => {
  return httpClient.get(`/apis/lesson-teacher-review/topic/get?uuid=${uuid}`);
};

const createLessonTeacherReviewTopic = (topic): Promise<ApiResponse<ForumTopicModel>> => {
  return httpClient.post(`/apis/lesson-teacher-review/topic/create`, topic);
};

const fetchLessonTeacherReviewTopicResourceList = (
  params,
): Promise<ApiResponse<PaginatedResultModel<ForumTopicResourceModel>>> => {
  return httpClient.get(
    `/apis/lesson-teacher-review/topic-resource/list?topicId=${params.topicId}&pageSize=${params.pageSize}&forumTopicResourceId=${params.topicResourceId}`,
  );
};

const createLessonTeacherReviewTopicResource = (requestData): Promise<ApiResponse> => {
  return httpClient.post(`/apis/lesson-teacher-review/topic-resource/create`, requestData, {
    headers: {
      "X-With-Richtext": true,
    },
  });
};

const editLessonTeacherReviewTopicResource = (
  params,
): Promise<ApiResponse<ForumTopicResourceModel>> => {
  return httpClient.post(
    `/apis/lesson-teacher-review/topic-resource/edit/${params.uuid}`,
    params.postModel,
    {
      headers: {
        "X-With-Richtext": true,
      },
    },
  );
};

const deleteLessonTeacherReviewTopicResource = (uuid): Promise<ApiResponse> => {
  return httpClient.post(`/apis/lesson-teacher-review/topic-resource/delete/${uuid}`);
};

const fetchLessonAdminReviewTopic = (params): Promise<ApiResponse<ForumTopicModel>> => {
  return httpClient.get(
    `/apis/lesson-admin-review/topic/get?uuid=${params.uuid}&status=${params.status}&domain=${params.domain}`,
  );
};

const createLessonAdminReviewTopic = (topic): Promise<ApiResponse<ForumTopicModel>> => {
  return httpClient.post(`/apis/lesson-admin-review/topic/create`, topic);
};

const fetchLessonAdminReviewTopicResourceList = (
  params,
): Promise<ApiResponse<PaginatedResultModel<ForumTopicResourceModel>>> => {
  return httpClient.get(
    `/apis/lesson-admin-review/topic-resource/list?topicId=${params.topicId}&pageSize=${params.pageSize}&forumTopicResourceId=${params.topicResourceId}`,
  );
};

const editLessonAdminReviewTopicResource = (
  params,
): Promise<ApiResponse<ForumTopicResourceModel>> => {
  return httpClient.post(
    `/apis/lesson-admin-review/topic-resource/edit/${params.uuid}`,
    params.postModel,
    {
      headers: {
        "X-With-Richtext": true,
      },
    },
  );
};

const deleteLessonAdminReviewTopicResource = (uuid): Promise<ApiResponse> => {
  return httpClient.post(`/apis/lesson-admin-review/topic-resource/delete/${uuid}`);
};

export default {
  fetchLessonTeacherReviewTopic,
  createLessonTeacherReviewTopic,
  fetchLessonTeacherReviewTopicResourceList,
  createLessonTeacherReviewTopicResource,
  editLessonTeacherReviewTopicResource,
  deleteLessonTeacherReviewTopicResource,
  fetchLessonAdminReviewTopic,
  createLessonAdminReviewTopic,
  fetchLessonAdminReviewTopicResourceList,
  editLessonAdminReviewTopicResource,
  deleteLessonAdminReviewTopicResource,
};
